import React, { FC, ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface MigrationComparisonSectionProps {
  title: string;
  before: ReactNode;
  after: ReactNode;
}

export const MigrationComparisonSection: FC<MigrationComparisonSectionProps> = ({
  title,
  before,
  after,
}) => (
  <Box
    sx={{
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 1,
      mb: 2,
      overflow: 'hidden',
    }}
  >
    <Typography variant="subtitle2" sx={{ fontWeight: 700, px: 1.5, py: 1, bgcolor: 'grey.100' }}>
      {title}
    </Typography>
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: 'minmax(0, 1fr) minmax(0, 1fr)' },
      }}
    >
      <Box sx={{ p: 1.5, minWidth: 0 }}>
        <Typography
          variant="overline"
          color="textSecondary"
          sx={{ display: 'block', lineHeight: 1, mb: 1 }}
        >
          Before
        </Typography>
        {before}
      </Box>
      <Box
        sx={{
          p: 1.5,
          minWidth: 0,
          bgcolor: 'action.hover',
          borderTop: { xs: '1px solid', md: 0 },
          borderLeft: { xs: 0, md: '1px solid' },
          borderColor: 'divider',
        }}
      >
        <Typography
          variant="overline"
          color="primary"
          sx={{ display: 'block', lineHeight: 1, mb: 1 }}
        >
          After · Editable
        </Typography>
        {after}
      </Box>
    </Box>
  </Box>
);
